import React from 'react';
import { NavLink } from 'react-router-dom';
import { getNavItems } from '../../support/iconMappings';

export const appNavLinkClass = ({ isActive }) =>
  `inline-flex items-center gap-1.5 text-sm transition-colors ${
    isActive ? 'text-forge-600 font-medium' : 'text-content-muted hover:text-content-primary'
  }`;

function AppNav({
  user,
  items,
  isMultiAgent = false,
  currentMembership = null,
  className = 'hidden sm:flex items-center gap-4',
  onNavigate,
  linkClassName = appNavLinkClass,
}) {
  const navItems =
    items ||
    getNavItems(user, { isMultiAgent, currentMembership });

  if (!navItems.length) {
    return null;
  }

  return (
    <nav className={className} aria-label="Navegação principal">
      {navItems.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={linkClassName}
          onClick={onNavigate}
        >
          <Icon className="h-[18px] w-[18px] shrink-0" aria-hidden />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}

export default AppNav;
